export const ClientRoutes = {
  Home: '/',
  signIn: '/sign-in',
  signUp: '/sign-up',
  resetPassword: '/reset-password',
  forgotPassword: '/forgot-password',
  verifyPin: '/verify-pin',
  profile: '/account',
  invoices: '/invoices',
  history: '/history',
  process: '/process',
  contact: '/contact',
}

// Routes that should not be accessed by authenticated users
export const restrictedRoutes = [
  ClientRoutes.signIn,
  ClientRoutes.signUp,
  ClientRoutes.forgotPassword,
  ClientRoutes.resetPassword,
  ClientRoutes.verifyPin,
]

// Routes that should be accessed by authenticated users
export const protectedRoutes = [
  ClientRoutes.profile,
  ClientRoutes.invoices,
  ClientRoutes.history,
  ClientRoutes.process,
]
